/* eslint-disable no-restricted-imports */
/* eslint eqeqeq: "off" */
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import Badge from "react-bootstrap/Badge";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { shallowEqual, useSelector } from "react-redux";

import moment from "moment";
import { convertFrom24To12Format } from "../../../../helpers/TimeConvert";
import { ProgramTableActions } from "./ActionFormatter/ProgramTableActions";
import { useProgramContext } from "./ProgramDataContext";
import { SchoolProgramCoachTable, SchoolProgramStudentTable } from "./SchoolProgramCoachAndStudentTables";

const useStyles = makeStyles((theme) => ({
  warningRatio: {
    color: "white",
    background: "#eed202",
  },
  dangerRatio: {
    color: "white",
    background: "#F32013",
  },
  successRatio: {
    color: "white",
    background: "#4BB543",
  },
  tableWrapper: {
    overflowX: "auto",
  },
}));

let icons = {
  1: {
    icon: "fas fa-school",
    value: "Regular Class",
    css: "svg-icon-muted",
    icon_css: "text-muted",
  },
  2: {
    icon: "fas fa-sun",
    value: "Summer Camp",
    css: "svg-icon-muted",
    icon_css: "text-muted",
  },
  3: {
    icon: "fas fa-running",
    value: "Trackout Camp",
    css: "svg-icon-danger",
    icon_css: "text-danger",
  },
  5: {
    icon: "fas fa-snowflake",
    value: "Winter Camp",
    css: "svg-icon-primary",
    icon_css: "text-primary",
  },
  6: {
    icon: "fas fa-seedling",
    value: "Spring Break Camp",
    css: "svg-icon-success",
    icon_css: "text-success",
  },
};

export default function ProgramRow(props) {
  const classes = useStyles();
  const { row, reset, setReset, showActions } = props;
  const [open, setOpen] = useState(false);
  const [programOpen, setProgramOpen] = useState("");
  const [studentList, setStudentList] = useState([]);
  const token = useSelector((state) => state.auth.authToken, shallowEqual);
  const branch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );
  const SCHOOL_PROGRAM_URL = "/api/school-programs";
  const classRatio = (studentCount) => {
    return studentCount
      ? studentCount / row.maximum_student
      : 0 / row.maximum_student;
  };
  const schoolProgramContext = useProgramContext();

  const getCourses = (courses) => {
    let text = "";
    if (courses) {
      courses.forEach((c, index) => {
        text +=
          index % 3 == 0 && index != 0
            ? c.course_code + "\n"
            : index == courses.length - 1
            ? c.course_code
            : c.course_code + ", ";
      });
    }

    return text.split("\n");
  };

  async function fetchStudentsInProgram() {
    const response = await axios.get(
      `${SCHOOL_PROGRAM_URL}/${row.school_program_id}/all-students`
    );
    setStudentList(response.data.results.program_students);
  }

  useEffect(() => {
    programOpen && fetchStudentsInProgram();
    // eslint-disable-next-line
  }, [programOpen]);

  const handleRowClick = (school_program_id) => {
    setOpen(!open);
    setProgramOpen(school_program_id);
    reset && setReset(false);
  };

  return (
    <Fragment>
      <TableRow key={row.school_program_id} hover tabIndex={-1}>
        <TableCell component="th" scope="row">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => handleRowClick(row.school_program_id)}
          >
            {open && !reset ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </IconButton>
          {row.school_program_id}
        </TableCell>
        <TableCell align="left">{row.school_name}</TableCell>
        <TableCell align="center">
          <p>
            {classRatio(row.student_count) < 0.25 ? (
              <Badge pill className={classes.successRatio}>
                {row.student_count
                  ? row.student_count + "/" + row.maximum_student
                  : "0/" + row.maximum_student}
              </Badge>
            ) : classRatio(row.student_count) < 0.75 ? (
              <Badge pill className={classes.warningRatio}>
                {row.student_count
                  ? row.student_count + "/" + row.maximum_student
                  : "0/" + row.maximum_student}
              </Badge>
            ) : (
              <Badge pill className={classes.dangerRatio}>
                {row.student_count
                  ? row.student_count + "/" + row.maximum_student
                  : "0/" + row.maximum_student}
              </Badge>
            )}
          </p>
          {row.class_full_ind == 1 && (
            <div>
              <Badge variant="danger">FULL</Badge>
            </div>
          )}
          {row.web_register_ind == 1 && (
            <div>
              <Badge variant="info" title="Register on website is on">
                WEB
              </Badge>
            </div>
          )}
        </TableCell>
        <TableCell align="center">
          {row.day.includes(",")
            ? row.day.split(",").map((d, i) => <p key={i}>{d}</p>)
            : row.day}
        </TableCell>
        <TableCell align="center">
          {moment(row.startdate, "YYYY-MM-DD").format("MMM D, YYYY")} -{" "}
          {moment(row.enddate, "YYYY-MM-DD").format("MMM D, YYYY")}
        </TableCell>

        <TableCell align="center" component="th" scope="row">
          {convertFrom24To12Format(row.start_time)} -{" "}
          {convertFrom24To12Format(row.end_time)}
        </TableCell>

        <TableCell align="center" component="th" scope="row">
          {getCourses(row.courses).map((course, index) => (
            <p key={index + row.school_program_id}>{course}</p>
          ))}
        </TableCell>
        {showActions && (
          <TableCell align="center">
            <ProgramTableActions
              row={row}
              openEditProgramPage={schoolProgramContext.openEditProgramPage}
              openDeleteProgramDialog={
                schoolProgramContext.openDeleteProgramDialog
              }
              openActivateProgramDialog={
                schoolProgramContext.openActivateProgramDialog
              }
              openDuplicateProgramPage={
                schoolProgramContext.openDuplicateProgramPage
              }
              openBulkUploadPage = {schoolProgramContext.openBulkUploadPage}
              openPointsDialog={schoolProgramContext.openPointsDialog}
              openEmailDialog={schoolProgramContext.openEmailDialog}
              openAttendanceDialog={schoolProgramContext.openAttendanceDialog}
              openFullDialog={schoolProgramContext.openFullDialog}
            />
          </TableCell>
        )}
      </TableRow>
      <TableRow key={"details" + row.school_program_id}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={showActions ? 8 : 7}>
          <Collapse in={open && !reset} timeout="auto" unmountOnExit>
            <Box
              padding={2}
              margin={3}
              style={{ backgroundColor: "#f5f5f5", borderRadius: "0.5rem" }}
            >
              <Container>
                <Row className="mb-3">
                  <Col>
                    <SchoolProgramCoachTable instructors={row.instructor} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <SchoolProgramStudentTable
                      students={studentList}
                      tableLabel={"School Program Students"}
                      firstAndLastName={true}
                      // lastChallengeSubmissions={lastChallengeSubmissions}
                    />
                  </Col>
                </Row>
              </Container>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}
